import { useStripeForMAC } from 'modules/stripe-credit-card';
import { useCallback } from 'react';

export const useStripeOnSubmitMAC = (submit) => {
  const submitPaymentMethod = useStripeForMAC();
  const stripeButtonOnClickCallback = useCallback(
    async (e) => {
      e.preventDefault();
      if (submitPaymentMethod === null) {
        return;
      }
      const { payload } = await submitPaymentMethod();

      if (payload !== undefined) {
        submit();
      }
    },
    [submitPaymentMethod, submit],
  );

  return submitPaymentMethod !== null ? stripeButtonOnClickCallback : null;
};
